// Frequency values as Custom-Api's CheckInFrequency enum defines them.
const CADENCE_BY_FREQUENCY = {
  1: 'every day',
  2: 'every week',
  3: 'every 2 weeks',
  4: 'every 3 weeks',
  5: 'every 4 weeks',
}

/**
 * The sentence under the check-in heading.
 *
 * The cadence is whatever the school configured, so it comes from the availability response.
 * Older API responses carry no frequency, and a wrong number is worse than none, so those get a
 * sentence that does not name one.
 */
export const checkInCadenceSentence = frequency => {
  const cadence = CADENCE_BY_FREQUENCY[frequency]
  return cadence
    ? `Complete your check-in ${cadence}.`
    : 'Complete your check-in whenever a new one is ready for you.'
}

/**
 * The line telling a pupil who has already submitted when their next check-in opens.
 *
 * The date is only known once the school's schedule can produce one, so a missing or
 * unparseable value says nothing rather than guessing.
 */
export const nextCheckInSentence = nextLaunchDate => {
  if (!nextLaunchDate) return ''

  const launchesOn = new Date(nextLaunchDate)
  if (Number.isNaN(launchesOn.getTime())) return ''

  return `Next check-in: ${launchesOn.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })}`
}

export default checkInCadenceSentence
